import ApiService, {callCustomMethodAsync} from '../service/ApiService';

let moduleApi = {};
let moduleName = "work";

moduleApi.create = async (dataForm) => { 
 let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.update = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter,loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: (loading == undefined ? false : loading ),
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: {id: id}
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id},
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.importWork = (value) => {
  let api = {
    module: moduleName,
    type: "ImportWork",
    body: value,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  return callCustomMethodAsync(api);
};

moduleApi.ApproveWork = async (value) => {
  let api = {
    module: moduleName,
    type: "ApproveWork",
    body: value,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.UnapproveWork = async (value) => {
  let api = {
    module: moduleName,
    type: "UnapproveWork",
    body: value,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.ApproveAllWorkBySalaryPeriod = async (value) => {
  let api = {
    module: moduleName,
    type: "ApproveAllWorkBySalaryPeriod",
    body: value,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.UpApproveAllWorkBySalaryPeriod = async (value) => {
  let api = {
    module: moduleName,
    type: "UpApproveAllWorkBySalaryPeriod",
    body: value,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.GoLateStatisticOfMonth = async (value,loading) => {
  let api = {
    module: moduleName,
    type: "GoLateStatisticOfMonth",
    body: value,
    message: {
      success: "hidden",
      error: "hidden"
    },
    dontLoading: (loading == undefined ? false : loading ),
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.saveWorkChange = async (value) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: value,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

export default moduleApi;
